'use strict'

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10

# Groupon.Utils.setSiteCookies:
module.exports = setSiteCookies = (cookies, seconds = TEN_YEARS_IN_SECONDS) ->
  cookieDomain = setSiteCookies.cookieDomain ||= $('head').data 'domain'
  for key, val of cookies
    if val?
      Cookie.set key, val, seconds, cookieDomain
    else
      Cookie.unset key, cookieDomain



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/setSiteCookies.coffee